import React from 'react';
import styled from 'styled-components';
import { SectionParent, H3, H1 } from '../../StyledComponents';
import ZeroTouch from '../../../assets/v2/Health/platform.svg';
import RemoteSupport from '../../../assets/v2/Health/seamless.svg';
import ApplicationLockdown from '../../../assets/v2/Health/protection.svg';
import { LazyLoadImage } from 'react-lazy-load-image-component';
const Section = styled(SectionParent)`
  display: grid;
  position: relative;
  justify-items: center;
  background: #ffffff;
  padding-bottom: 7rem !important;
  padding-top: 5rem !important;
  @media (max-width: 1680px) and (min-width: 1440px) {
    padding: 0rem 14rem;
  }
  @media (max-width: 1440px) and (min-width: 768px) {
    padding: 0rem 12rem;
  }
  @media (max-width: 520px) {
    padding-bottom: 3rem !important;
  }
`;

const StyledImg = styled(LazyLoadImage)`
  height: 46px;
`;
const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin-top: 2rem;
  border-radius: 4px;
  width: 82%;
  box-shadow: 0 3px 18px 0 rgba(72, 82, 108, 0.15);
  margin-bottom: 1rem;
  padding: 3rem;
  padding-right: 0;
  padding-bottom: 1rem;
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
    padding: 1rem;
    width: 100%;
  }
  @media (max-width: 520px) {
    grid-template-columns: repeat(1, 1fr);
    margin-top: 2.5rem;
  }
`;

const GridItem = styled.div`
  grid-column: span 1;
  border-radius: 5px;
  max-width: 80%;
  @media (max-width: 768px) {
    max-width: 100%;
    margin-bottom: 2rem;
  }
`;

const GridItemContent = styled(H3)`
  font-family: 'Nunito Sans', sans-serif;
  margin-bottom: 2rem;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.67;
  letter-spacing: normal;
  text-align: left;
  color: #736e79;
  @media (max-width: 768px) {
    text-align: center;
  }
  @media (max-width: 520px) {
    margin-bottom: 0;
  }
`;

const TitlesContainer = styled.div`
  padding-top: 0.5rem;
  @media (max-width: 768px) {
    text-align: center;
    padding-left: 0rem;
  }
`;
const GridTitle = styled.div`
  font-size: 20px;
  font-weight: 500;
  min-height: 2em;
  font-weight: bold;
  margin-bottom: 0.5rem;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #151828;
  @media (max-width: 520px) {
    min-height: 1.5rem;
    line-height: 1;
    margin-top: 0.5rem;
  }
`;

const ImgWrapper = styled.div`
  display: grid;
  align-items: center;
  margin-bottom: 0.5rem;
  @media (max-width: 768px) {
    justify-items: center;
    margin-bottom: 0;
  }
`;

const SectionTitle = styled(H1)`
  padding-top: 2rem;
  font-weight: bold;
  @media (min-width: 1440px) {
    font-size: 28px !important;
  }
  @media (max-width: 520px) {
    text-align: center;
    padding-top: 0;
  }
  font-family: 'Nunito Sans', sans-serif;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.92;
  letter-spacing: normal;
  color: #151828;
`;
export default () => (
  <>
    <Section>
      <SectionTitle>We’re Startup-Friendly</SectionTitle>
      <GridContainer>
        <GridItem>
          <ImgWrapper>
            <StyledImg src={ZeroTouch} />
          </ImgWrapper>
          <TitlesContainer>
            <GridTitle>One Platform for Android Healthcare IoT</GridTitle>
          </TitlesContainer>
          <GridItemContent>
            Esper is a single platform for your telehealth engineering team to
            manage your Android mobile devices in any environment, from your
            test lab to the hospital or a telemedicine patient’s home.
          </GridItemContent>
        </GridItem>
        <GridItem>
          <ImgWrapper>
            <StyledImg src={RemoteSupport} />
          </ImgWrapper>
          <TitlesContainer>
            <GridTitle>Seamless No-Touch Deployment</GridTitle>
          </TitlesContainer>
          <GridItemContent>
            Esper’s seamless, no-touch provisioning significantly improves the
            speed of deploying devices in a healthcare organization or a
            patient’s home. When devices are powered on, they automatically load
            up your configurations, compliance policies, and application
            experiences.
          </GridItemContent>
        </GridItem>
        <GridItem>
          {' '}
          <ImgWrapper>
            <StyledImg src={ApplicationLockdown} />
          </ImgWrapper>
          <TitlesContainer>
            <GridTitle>Protect Patient Data and Outcomes</GridTitle>
          </TitlesContainer>
          <GridItemContent>
            Esper offers a complete approach to protecting your telemedicine
            solution, from hardware to firmware and apps to help you meet the
            security requirements of the US FDA, EU MDR, ISO 13485 and other
            frameworks.
          </GridItemContent>
        </GridItem>
      </GridContainer>
    </Section>
  </>
);
